'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    margin-left: 15px;\n    margin-right: 15px;\n  '], ['\n    margin-left: 15px;\n    margin-right: 15px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    margin-top: 0;\n    align-self: center;\n  '], ['\n    margin-top: 0;\n    align-self: center;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      width: 100%;\n      flex-wrap: wrap;\n    '], ['\n      width: 100%;\n      flex-wrap: wrap;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        padding-left: 34px;\n        width: 50%;\n      '], ['\n        padding-left: 34px;\n        width: 50%;\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        padding: 0;\n        width: 100%;\n        text-align: center;\n      '], ['\n        padding: 0;\n        width: 100%;\n        text-align: center;\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n          text-align: right;\n        '], ['\n          text-align: right;\n        ']),
    _templateObject7 = _taggedTemplateLiteral(['\n          text-align: center;\n        '], ['\n          text-align: center;\n        ']),
    _templateObject8 = _taggedTemplateLiteral(['\n            margin-left: 34px;\n            margin-right: 0;\n          '], ['\n            margin-left: 34px;\n            margin-right: 0;\n          ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _StandardProductPageTitle = require('pricing-pages-unified-ui/components/product-pages/StandardProductPageTitle');

var _StandardProductPageTitle2 = _interopRequireDefault(_StandardProductPageTitle);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIcon = (0, _styledComponents2.default)(_UIIcon2.default).withConfig({
  displayName: 'GrowthSuiteTitle__StyledIcon'
})(['font-size:26px;line-height:44px;text-align:center;margin:0 30px 0;', ';', ';'], _responsiveBreakpoints2.default.tablet(_templateObject), _responsiveBreakpoints2.default.tabletPortrait(_templateObject2));

var StyledFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'GrowthSuiteTitle__StyledFlex'
})(['&.growth-suite-logos{', ' .growth-suite-logos__logo{white-space:nowrap;div{display:inline-block;}', ' ', ' &:nth-child(odd){', ' ', ' .growth-suite-icon{', '}}}}'], _responsiveBreakpoints2.default.tablet(_templateObject3), _responsiveBreakpoints2.default.tablet(_templateObject4), _responsiveBreakpoints2.default.tabletPortrait(_templateObject5), _responsiveBreakpoints2.default.tablet(_templateObject6), _responsiveBreakpoints2.default.tabletPortrait(_templateObject7), _responsiveBreakpoints2.default.tablet(_templateObject8));

var GrowthSuiteTitle = function GrowthSuiteTitle() {
  return _react2.default.createElement(
    StyledFlex,
    { className: 'growth-suite-logos', justify: 'between' },
    _react2.default.createElement(
      'div',
      { className: 'growth-suite-logos__logo' },
      _react2.default.createElement(_StandardProductPageTitle2.default, {
        className: 'growth-suite-logos__title',
        hub: 'crm',
        size: 'small'
      }),
      _react2.default.createElement(StyledIcon, { className: 'growth-suite-icon', name: 'add' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'growth-suite-logos__logo' },
      _react2.default.createElement(_StandardProductPageTitle2.default, { hub: 'marketing', size: 'small' }),
      _react2.default.createElement(StyledIcon, { className: 'growth-suite-icon', name: 'add' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'growth-suite-logos__logo' },
      _react2.default.createElement(_StandardProductPageTitle2.default, {
        className: 'growth-suite-logos__title',
        hub: 'sales',
        size: 'small'
      }),
      _react2.default.createElement(StyledIcon, { className: 'growth-suite-icon', name: 'add' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'growth-suite-logos__logo' },
      _react2.default.createElement(_StandardProductPageTitle2.default, {
        className: 'growth-suite-logos__title',
        hub: 'service',
        size: 'small'
      })
    )
  );
};

exports.default = GrowthSuiteTitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/GrowthSuiteTitle.js
// module id = 771
// module chunks = 3 4